// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_botaoOkCadastro__L0sIc {
  background-color: #18316e !important;
  color: #ffffff !important;
  width: 120px !important;
  font-family: "Inter" !important;
  text-transform: none !important;
  font-weight: 400 !important;
  transition: all 0.3s ease !important;
  margin: 12px 0px 12px 0px !important;
}

.styles_botaoOkCadastro__L0sIc:hover {
  transform: scale(0.95) !important;
}

.styles_tituloCadastroOk__EvaVG {
  font-family: "Inter" !important;
  text-align: center !important;
  margin-bottom: -24px !important;
}

.styles_imgLogo__jEo-W {
  width: 80px !important;
  height: auto !important;
  margin-top: 24px !important;
}

.styles_container__zOqBU {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

.styles_botaoLogout__Fk6RR {
  background-color: #18316e !important;
  color: #ffffff !important;
  width: 120px !important;
  font-family: "Inter" !important;
  text-transform: none !important;
  font-weight: 400 !important;
  transition: all 0.3s ease !important;
  margin: 12px 0px 12px 0px !important;
}

.styles_botaoLogout__Fk6RR:hover {
  transform: scale(0.95) !important;
}

.styles_imgPropostaAnalise__qsIS\\+ {
  width: 480px !important;
  height: auto !important;
  margin-top: 12px !important;
  margin-bottom: 12px !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: 8px !important;
}

.styles_tituloAnalise__Lfbar {
  color: #18316e !important;
  font-family: "Inter" !important;
  font-size: 24px !important;
}

.styles_textoAnalise__E\\+8Mh {
  color: #18316e !important;
}

.styles_botaoSim__VfbiX {
  background-color: #18316e !important;
  color: #ffffff !important;
  width: 120px !important;
  font-family: "Inter" !important;
  text-transform: none !important;
  font-weight: 400 !important;
  transition: all 0.3s ease !important;
  margin: 12px 24px 12px 0px !important;
}

.styles_botaoSim__VfbiX:hover {
  transform: scale(0.95) !important;
}

.styles_botaoNao__rQlOz {
  background-color: #ffffff !important;
  color: #18316e !important;
  width: 120px !important;
  font-family: "Inter" !important;
  text-transform: none !important;
  font-weight: 400 !important;
  transition: all 0.3s ease !important;
  margin: 12px 0px 12px 0px !important;
  border: solid !important;
  border-color: #18316e !important;
  border-width: 1px !important;
}

.styles_botaoNao__rQlOz:hover {
  transform: scale(0.95) !important;
}

.styles_divPrincipal__O4z-n {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: "calc(100vh - 9rem)";
}

.styles_contentTab__KC0MM {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-radius: 0 0 8px 8px;
  height: 100vh;
}

.styles_tab__OGvu1 {
  font-family: "Inter" !important;
}

.styles_paperChamadaForm__Znxwv {
  margin-top: 1.5rem !important;
  width: 30rem !important;
  min-width: 12rem !important;
  max-width: 30rem !important;
  padding: 1rem !important;
  background-color: #18316e !important;
  border-radius: 0.5rem !important;
}

.styles_iconeVerEditar__lLvgl {
  color: #fff !important;
}

.styles_iconeVerEditar__lLvgl:hover {
  background-color: rgba(255, 255, 255, 0.3) !important;
  border-radius: 50% !important;
}

.styles_pergunta__1gsGi {
  color: #18316e !important;
  text-align: center;
}

@media (max-width: 425px) {
  .styles_paperChamadaForm__Znxwv {
    width: 18rem !important;
  }

  .styles_textoChamadaForm__49Yza {
    font-size: 0.9rem !important;
  }
}

@media (min-width: 426px) {
  .styles_paperChamadaForm__Znxwv {
    width: 30rem !important;
  }
  .styles_iconeVerEditar__lLvgl {
    margin: 0 0.5rem 0 0 !important;
    padding: 0.15rem !important;
  }
}

.styles_textoChamadaForm__49Yza {
  padding: 0.5rem 1rem 0.5rem 0.5rem !important;
  font-family: "Inter" !important;
  text-align: left !important;
  justify-content: flex-start !important;
  color: #fff !important;
  font-weight: 500 !important;
}

.styles_divProperties__spsM3 {
  max-height: 20rem;
  overflow-y: scroll;
  box-shadow: inset 0 0 0.2rem rgba(18, 31, 6, 0.5);
  padding: 0.5rem;
  margin-top: 0.5rem;
  border-radius: 0.5rem;
}

.styles_widget__lX8M-{
  margin-left: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,oCAAoC;EACpC,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".botaoOkCadastro {\n  background-color: #18316e !important;\n  color: #ffffff !important;\n  width: 120px !important;\n  font-family: \"Inter\" !important;\n  text-transform: none !important;\n  font-weight: 400 !important;\n  transition: all 0.3s ease !important;\n  margin: 12px 0px 12px 0px !important;\n}\n\n.botaoOkCadastro:hover {\n  transform: scale(0.95) !important;\n}\n\n.tituloCadastroOk {\n  font-family: \"Inter\" !important;\n  text-align: center !important;\n  margin-bottom: -24px !important;\n}\n\n.imgLogo {\n  width: 80px !important;\n  height: auto !important;\n  margin-top: 24px !important;\n}\n\n.container {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-align: center !important;\n}\n\n.botaoLogout {\n  background-color: #18316e !important;\n  color: #ffffff !important;\n  width: 120px !important;\n  font-family: \"Inter\" !important;\n  text-transform: none !important;\n  font-weight: 400 !important;\n  transition: all 0.3s ease !important;\n  margin: 12px 0px 12px 0px !important;\n}\n\n.botaoLogout:hover {\n  transform: scale(0.95) !important;\n}\n\n.imgPropostaAnalise {\n  width: 480px !important;\n  height: auto !important;\n  margin-top: 12px !important;\n  margin-bottom: 12px !important;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  border-radius: 8px !important;\n}\n\n.tituloAnalise {\n  color: #18316e !important;\n  font-family: \"Inter\" !important;\n  font-size: 24px !important;\n}\n\n.textoAnalise {\n  color: #18316e !important;\n}\n\n.botaoSim {\n  background-color: #18316e !important;\n  color: #ffffff !important;\n  width: 120px !important;\n  font-family: \"Inter\" !important;\n  text-transform: none !important;\n  font-weight: 400 !important;\n  transition: all 0.3s ease !important;\n  margin: 12px 24px 12px 0px !important;\n}\n\n.botaoSim:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoNao {\n  background-color: #ffffff !important;\n  color: #18316e !important;\n  width: 120px !important;\n  font-family: \"Inter\" !important;\n  text-transform: none !important;\n  font-weight: 400 !important;\n  transition: all 0.3s ease !important;\n  margin: 12px 0px 12px 0px !important;\n  border: solid !important;\n  border-color: #18316e !important;\n  border-width: 1px !important;\n}\n\n.botaoNao:hover {\n  transform: scale(0.95) !important;\n}\n\n.divPrincipal {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  height: \"calc(100vh - 9rem)\";\n}\n\n.contentTab {\n  background-color: #ffffff;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  border-radius: 0 0 8px 8px;\n  height: 100vh;\n}\n\n.tab {\n  font-family: \"Inter\" !important;\n}\n\n.paperChamadaForm {\n  margin-top: 1.5rem !important;\n  width: 30rem !important;\n  min-width: 12rem !important;\n  max-width: 30rem !important;\n  padding: 1rem !important;\n  background-color: #18316e !important;\n  border-radius: 0.5rem !important;\n}\n\n.iconeVerEditar {\n  color: #fff !important;\n}\n\n.iconeVerEditar:hover {\n  background-color: rgba(255, 255, 255, 0.3) !important;\n  border-radius: 50% !important;\n}\n\n.pergunta {\n  color: #18316e !important;\n  text-align: center;\n}\n\n@media (max-width: 425px) {\n  .paperChamadaForm {\n    width: 18rem !important;\n  }\n\n  .textoChamadaForm {\n    font-size: 0.9rem !important;\n  }\n}\n\n@media (min-width: 426px) {\n  .paperChamadaForm {\n    width: 30rem !important;\n  }\n  .iconeVerEditar {\n    margin: 0 0.5rem 0 0 !important;\n    padding: 0.15rem !important;\n  }\n}\n\n.textoChamadaForm {\n  padding: 0.5rem 1rem 0.5rem 0.5rem !important;\n  font-family: \"Inter\" !important;\n  text-align: left !important;\n  justify-content: flex-start !important;\n  color: #fff !important;\n  font-weight: 500 !important;\n}\n\n.divProperties {\n  max-height: 20rem;\n  overflow-y: scroll;\n  box-shadow: inset 0 0 0.2rem rgba(18, 31, 6, 0.5);\n  padding: 0.5rem;\n  margin-top: 0.5rem;\n  border-radius: 0.5rem;\n}\n\n.widget{\n  margin-left: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoOkCadastro": `styles_botaoOkCadastro__L0sIc`,
	"tituloCadastroOk": `styles_tituloCadastroOk__EvaVG`,
	"imgLogo": `styles_imgLogo__jEo-W`,
	"container": `styles_container__zOqBU`,
	"botaoLogout": `styles_botaoLogout__Fk6RR`,
	"imgPropostaAnalise": `styles_imgPropostaAnalise__qsIS+`,
	"tituloAnalise": `styles_tituloAnalise__Lfbar`,
	"textoAnalise": `styles_textoAnalise__E+8Mh`,
	"botaoSim": `styles_botaoSim__VfbiX`,
	"botaoNao": `styles_botaoNao__rQlOz`,
	"divPrincipal": `styles_divPrincipal__O4z-n`,
	"contentTab": `styles_contentTab__KC0MM`,
	"tab": `styles_tab__OGvu1`,
	"paperChamadaForm": `styles_paperChamadaForm__Znxwv`,
	"iconeVerEditar": `styles_iconeVerEditar__lLvgl`,
	"pergunta": `styles_pergunta__1gsGi`,
	"textoChamadaForm": `styles_textoChamadaForm__49Yza`,
	"divProperties": `styles_divProperties__spsM3`,
	"widget": `styles_widget__lX8M-`
};
export default ___CSS_LOADER_EXPORT___;
